// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-file:not(.track-manager__button){position:relative;display:inline-block;border-radius:3px;margin-bottom:15px;padding:10px 15px !important;background:#74b332;font-size:16px;color:#fff;cursor:pointer;clear:both}.input-file.input-file--small{margin-bottom:0;padding:8px 12px !important;font-size:12px;font-weight:600}.input-file input{position:absolute;top:0;left:0;opacity:0;width:1%;height:1%;z-index:-1}", ""]);
// Exports
module.exports = exports;
